import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import ListSubheader from "@mui/material/ListSubheader";
import MenuItem from "@mui/material/MenuItem";
import MenuList from "@mui/material/MenuList";
import { Link, useLocation } from "react-router-dom";
import { pathMatches, type NavSection } from "./navItems";

interface FlyoutLinkListProps {
  /** Items carry their final link target in `path`. Empty sections are skipped. */
  sections: NavSection[];
  /** Called after a link is chosen, to close the flyout. */
  onNavigate: () => void;
}

/** The sections of links in a sidebar flyout (Explore, Platform). */
export default function FlyoutLinkList({ sections, onNavigate }: FlyoutLinkListProps) {
  const { pathname } = useLocation();
  return (
    // Flat children: a MenuList walks its direct children for arrow-key focus.
    <MenuList>
      {sections
        .filter((section) => section.items.length > 0)
        .flatMap((section, i) => [
          section.heading && (
            <ListSubheader key={`heading-${section.heading ?? i}`}>{section.heading}</ListSubheader>
          ),
          ...section.items.map((item) => (
            <MenuItem
              key={item.path}
              component={Link}
              to={item.path}
              selected={pathMatches(pathname, item.path)}
              onClick={onNavigate}
            >
              <ListItemIcon>{item.icon}</ListItemIcon>
              <ListItemText primary={item.label} />
            </MenuItem>
          )),
        ])}
    </MenuList>
  );
}
